import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { get, isNumber } from 'lodash';
import moment from 'moment';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { SizeFittingTable } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { paymentStatusText } from 'src/pages/Order/AllOrders/OrderList/config';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { formatTimeBySetting, generalSort } from 'src/tools/helper';
import { EnumTablePosition } from 'src/types/common/common';

import { getBasicSetting } from '@/src/constrains/GlobalProvider/slice';
import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet, handleOnGetStoreTimezoneUTC } from '@/src/tools/tools';
import { useSelector } from 'react-redux';
import css from './css.module.less';

const Usage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const timezoneInUTC = handleOnGetStoreTimezoneUTC();
  // format 需要从这里读取
  const config = useSelector(getBasicSetting());
  const h = useHistory();
  const { list, currency } = props;
  const col = () => {
    return [
      {
        minWidth: 160,
        title: (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_modified_title',
            )}{' '}
            {`(UTC ${timezoneInUTC})` && <div>{`(UTC ${timezoneInUTC})`}</div>}
          </div>
        ),
        key: 'Sku',
        default: true,
        sorter: (a, b) => {
          const format = formatTimeBySetting(config);
          const time1 = moment(
            get(a, 'modifiedDate', new Date()),
            format,
          ).valueOf();
          const time2 = moment(
            get(b, 'modifiedDate', new Date()),
            format,
          ).valueOf();
          return time1 > time2 ? 1 : -1;
        },
        childGenerate: (a, record, index) => {
          const modifiedDate = get(record, 'modifiedDate') || '-';
          return (
            <NoWrapContainer>
              <Tooltip title={modifiedDate}>{modifiedDate}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        minWidth: 180,
        title: (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_id_title',
            )}
          </div>
        ),
        key: 'Order ID',
        sorter: (a, b) => {
          const name1 = get(a, 'order.orderNo');
          const name2 = get(b, 'order.orderNo');
          return generalSort(name1, name2);
        },
        default: true,
        childGenerate: (a, record, index) => {
          const orderNo = get(record, 'order.orderNo');
          return (
            <NoWrapContainer>
              <Tooltip title={orderNo}>{orderNo}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        minWidth: 100,
        title: (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_status_title',
            )}
          </div>
        ),
        key: 'Status',
        default: true,
        childGenerate: (a, record, index) => {
          const status = get(record, 'order.paymentStatus');
          //console.log('status', status);
          const s = paymentStatusText[status] || '-';
          return (
            <NoWrapContainer>
              <Tooltip title={s}>{s}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        minWidth: 168,
        title: (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_saleschannel_title',
            )}
          </div>
        ),
        key: 'Sales Channel',
        default: true,
        childGenerate: (a, record, index) => {
          const salesChannelName = get(record, 'order.salesChannelName') || '-';
          return (
            <NoWrapContainer>
              <Tooltip title={salesChannelName}>{salesChannelName}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        minWidth: 140,
        title: (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_adjustment_title',
            )}
            {currency ? `(${currency})` : ''}
          </div>
        ),
        key: 'Adjustment',
        default: true,
        childGenerate: (a, record, index) => {
          const total = get(record, 'total');
          const status = get(record, 'status');
          let display: any = '-';
          if (isNumber(total)) {
            if (status === 'REFUNDED') {
              display = (
                <span className={css.positiveNum}>{`+ ${Math.abs(
                  total,
                )}`}</span>
              );
            } else if (status === 'CHARGED') {
              display = <span className={css.negativeNum}>{`- ${total}`}</span>;
            } else {
              display = 0;
            }
          } else {
            display = 0;
          }

          return (
            <NoWrapContainer>
              <Tooltip title={total}>{display}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        minWidth: 140,
        titleGenerate: () => (
          <div>
            {getI18n(
              'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_balance_title',
            )}
            {currency ? `(${currency})` : ''}
          </div>
        ),
        position: EnumTablePosition.right,
        key: 'balance',
        default: true,
        childGenerate: (a, record, index) => {
          const balance = get(record, 'balance');
          return (
            <NoWrapContainer>
              <Tooltip title={balance}>{balance}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      {
        titleGenerate: () =>
          getI18n(
            'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_actions_title',
          ),
        position: EnumTablePosition.right,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          const uuid = get(record, 'order.uuid');
          return (
            <Actions
              editText={getI18n(
                'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_colreturn_actions_editText',
              )}
              onEdit={() => {
                h.push(`/order/${uuid}`);
                // if (onView) {
                //   onView(uuid);
                // }
                //  remove(index);
              }}
            />
          );
        },
        fixedWidth: 100,
      },
    ];
  };

  return (
    <SectionWrapper
      // titleClassName={css.titleContainer}
      containerClassName={css.sectionContainer}
      title={getI18n(
        'giftCard.giftCardDetail.giftCardAndStoreCredit_Usage_return_usage_title',
      )}>
      <SizeFittingTable
        rowKey='uuid'
        pagination={false}
        dataSource={list || []}
        id={`OrderGiftCardUsageTable`}
        columns={col()}
      />
    </SectionWrapper>
  );
};
export default Usage;
